import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import color from "../../Constants/colors";

interface CircleProps {
  colored: boolean;
  number: number;
  isActive?: boolean;
}

const Circle = styled(Box, {
  shouldForwardProp: (prop) => prop !== "colored" && prop !== "isActive",
})<CircleProps>(({ colored }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: colored ? "white" : color.primary_dark,
  border: colored ? `3px solid ${color.accent}` : `2px solid ${color.gray300}`,
  backgroundColor: colored ? color.accent : color.white,
  borderRadius: "50%",
  width: "72px",
  height: "72px",
  marginTop: 1,
  marginBottom: 1,
  transition: "all 0.3s ease",
  boxShadow: colored
    ? `0 2px 8px rgba(0, 0, 0, 0.15)`
    : `0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.1)`,
  position: "relative",
  "&:hover": {
    transform: colored ? "scale(1.05)" : "scale(1.02)",
    boxShadow: colored
      ? `0 4px 12px rgba(0, 0, 0, 0.2)`
      : `0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.15)`,
  },
}));

export default Circle;
